import React from "react";
import PageLayout from "../components/PageLayout";

export default function Portfolio() {
  const cards = [
    {
      title: "Formação corporativa",
      text: "Programas realizados para equipas que precisavam de reforçar produtividade, atendimento e competências digitais.",
      points: [
        "Conteúdo adaptado",
        "Exercícios do contexto real",
        "Relatório final",
      ],
    },
    {
      title: "Comunicação institucional",
      text: "Produção de materiais consistentes para eventos, atendimento, apresentações e divulgação.",
      points: ["Design", "Impressão", "Acabamento"],
    },
    {
      title: "Apoio tecnológico",
      text: "Organização de equipamentos, ferramentas e rotinas para ambientes de trabalho mais eficientes.",
      points: ["Diagnóstico", "Configuração", "Suporte"],
    },
  ];
  return (
    <PageLayout
      eyebrow="Portfólio"
      title="Resultados que mostram como trabalhamos."
      intro="Cada projecto começa com uma necessidade concreta. Aqui apresentamos os tipos de desafio em que a nossa equipa tem aplicado formação, tecnologia e produção."
      sectionTitle="Projectos construídos com método e proximidade"
      sectionIntro="Por respeito à confidencialidade, alguns trabalhos são apresentados por categoria. A equipa pode partilhar referências adequadas durante a consulta."
      cards={cards}
    />
  );
}
